import React from 'react';
import { FlexBox } from '@vp/swan';
import { __, __product } from '@99designs/i18n';
import ModalSubheader from './ModalSubheader';
import MoreDesignsCard from './MoreDesignsCard';
import {
    FoldedLeafletDesignIcon,
    LetterheadDesignIcon,
    PostcardDesignIcon,
    RetractableBannerDesignIcon,
    ReturnAddressLabelDesignIcon,
    WeddingInvitationDesignIcon,
} from './icons';

function urlFromMpvId(mpvId: string) {
    return `/design/briefs/create/care-design?mpvId=${mpvId}`;
}

export default function MoreDesignCards() {
    // All destination page names are the same for these links.

    const destinationPageName = 'Design Services:Printed Product Brief';
    return (
        <FlexBox flexDirection="column" gap={'between-actions'}>
            <ModalSubheader>{__('More design options')}</ModalSubheader>
            <MoreDesignsCard
                destinationUrl={urlFromMpvId(__product('mpv-id-brochure'))}
                destinationPageName={destinationPageName}
                icon={<FoldedLeafletDesignIcon />}
                title={__('Folded Leaflet design')}
                position={5}
            />
            <MoreDesignsCard
                destinationUrl={urlFromMpvId(__product('mpv-id-letterhead'))}
                destinationPageName={destinationPageName}
                icon={<LetterheadDesignIcon />}
                title={__('Letterhead design')}
                position={6}
            />
            <MoreDesignsCard
                destinationUrl={urlFromMpvId(__product('mpv-id-postcard'))}
                destinationPageName={destinationPageName}
                icon={<PostcardDesignIcon />}
                title={__('Postcard design')}
                position={7}
            />
            <MoreDesignsCard
                destinationUrl={urlFromMpvId(__product('mpv-id-retractable-banner'))}
                destinationPageName={destinationPageName}
                icon={<RetractableBannerDesignIcon />}
                title={__('Retractable Banner design')}
                position={8}
            />
            <MoreDesignsCard
                destinationUrl={urlFromMpvId(__product('mpv-id-return-address-labels'))}
                destinationPageName={destinationPageName}
                icon={<ReturnAddressLabelDesignIcon />}
                title={__('Return Address Label design')}
                position={9}
            />
            <MoreDesignsCard
                destinationUrl={urlFromMpvId(__product('mpv-id-wedding-invitations'))}
                destinationPageName={destinationPageName}
                icon={<WeddingInvitationDesignIcon />}
                title={__('Wedding Invitation design')}
                position={10}
                destinationUrlQuery={{ isWeddingIllustration: 'true' }}
            />
        </FlexBox>
    );
}
